import { render, staticRenderFns } from "./AffectsOffersList.vue?vue&type=template&id=2e4ab704&scoped=true&"
import script from "./AffectsOffersList.vue?vue&type=script&lang=js&"
export * from "./AffectsOffersList.vue?vue&type=script&lang=js&"
import style0 from "./AffectsOffersList.vue?vue&type=style&index=0&id=2e4ab704&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4ab704",
  null
  
)

export default component.exports